import { brandName, brandSlogan, navAnchors } from "@/mocks/gossip";

export default function SiteFooter() {
  return (
    <footer className="border-t border-accent-200/70 bg-accent-100/50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg leading-none">
                <span aria-hidden="true">🍉</span>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">{brandName}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-700">
              专注热点事件的内幕细节与真相还原。我们不抢最快，只求把瓜吃透——用可溯源的时间线、交叉验证的信源，陪你把每一个「大瓜」看完第三集。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="rounded-full bg-accent-200/70 px-3 py-1 text-xs font-semibold text-accent-800">
                {brandSlogan}
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
                信源可追溯
              </span>
              <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
                结论可留白
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="flex items-center gap-1.5 text-sm font-bold text-foreground-950">
              <a href="#home">快速导航</a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5 text-sm md:grid-cols-1">
              {navAnchors.filter((a) => a.href !== "#home").map((a) => (
                <li key={a.href}>
                  <a href={a.href} className="whitespace-nowrap text-foreground-600 transition-colors hover:text-primary-600">
                    {a.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="flex items-center gap-1.5 text-sm font-bold text-foreground-950">
              <i className="ri-newspaper-line h-4 w-4 text-primary-600"></i>
              <span>热门频道</span>
            </h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {["娱乐圈", "社会热点", "商业财经", "网络热议", "科技圈", "体育圈"].map((c) => (
                <li key={c}>
                  <a
                    href="#channels"
                    className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-800"
                  >
                    # {c}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-xs leading-6 text-foreground-600">
              商务与线索合作：tougao@tangxin-chigua.example
              <br />
              编辑转载授权：media@tangxin-chigua.example
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-accent-200/70 pt-6 text-xs text-foreground-600 sm:flex-row">
          <p>© {new Date().getFullYear()} {brandName} · 理性吃瓜，先求证再下结论</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line h-4 w-4 text-accent-600"></i>
            内容仅供参考，请以官方信源为准
          </p>
        </div>
      </div>
    </footer>
  );
}